import React, { useState, useEffect } from 'react';
import { Save } from 'lucide-react';
import './WhatsAppGeneralSettings.css'; // Подключаем наши стили

const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export default function WhatsAppGeneralSettings({ selectedBranchId }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    company_name: '',
    description: '',
    phone: '',
    website: '',
    address: '',
    city: '',
    timezone: 'Asia/Almaty',
    language: 'ru'
  });

  useEffect(() => {
    if (!selectedBranchId) return;

    const fetchSettings = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/whatsapp/settings?branchId=${selectedBranchId}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token') || ''}` }
        });
        if (response.ok) {
          const data = await response.json();
          if (data) {
            setFormData(prev => ({ ...prev, ...data }));
          }
        }
      } catch (error) {
        console.error('Ошибка при загрузке сведений:', error);
      }
    };

    fetchSettings();
  }, [selectedBranchId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${apiUrl}/api/whatsapp/settings?branchId=${selectedBranchId}`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token') || ''}` 
        },
        body: JSON.stringify(formData)
      });
      
      if (!response.ok) throw new Error('Ошибка при сохранении');
      alert('Сведения успешно сохранены!');
    } catch (error) {
      alert('Не удалось сохранить настройки');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="whatsapp-panel whatsapp-general-settings">
      <h2>Сведения о компании</h2>
      <p className="whatsapp-muted">Эти данные используются ботом для предоставления контактной информации клиентам.</p>
      
      <div className="whatsapp-form-grid">
        <label>
          Название компании
          <input type="text" name="company_name" value={formData.company_name} onChange={handleChange} placeholder="ТОО Ромашка" />
        </label>
        
        <label>
          Описание
          <textarea name="description" value={formData.description} onChange={handleChange} placeholder="Краткое описание деятельности..." />
        </label>

        <div className="whatsapp-form-row">
          <label>
            Телефон
            <input type="text" name="phone" value={formData.phone} onChange={handleChange} placeholder="+7 700 123 45 67" />
          </label>
          
          <label>
            Веб-сайт
            <input type="text" name="website" value={formData.website} onChange={handleChange} placeholder="https://example.com" />
          </label>
        </div>

        <div className="whatsapp-form-row">
          <label className="flex-2">
            Адрес
            <input type="text" name="address" value={formData.address} onChange={handleChange} placeholder="пр. Абая 10, оф. 15" />
          </label>

          <label>
            Город
            <input type="text" name="city" value={formData.city} onChange={handleChange} placeholder="Алматы" />
          </label>
        </div>

        <div className="whatsapp-form-row">
          <label>
            Часовой пояс
            <select name="timezone" value={formData.timezone} onChange={handleChange}>
              <option value="Asia/Almaty">Asia/Almaty(UTC+5)</option>
              {/* <option value="Asia/Astana">Asia/Astana</option> */}
            </select>
          </label>
          
          <label>
            Язык по умолчанию
            <select name="language" value={formData.language} onChange={handleChange}>
              <option value="ru">Русский (ru)</option>
              <option value="kk">Казахский (kk)</option>
              <option value="en">Английский (en)</option>
            </select>
          </label>
        </div>

        <div className="whatsapp-save-wrapper">
          <button 
            className="whatsapp-action" 
            onClick={handleSave} 
            disabled={loading}
          >
            <Save size={18} style={{ marginRight: '8px' }} />
            {loading ? 'Сохранение...' : 'Сохранить сведения'}
          </button>
        </div>
      </div>
    </div>
  );
}